/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Compliance_Template_Patterns_Count_OneInputs */



/**
* | output |
* | --- |
* | "{count} pattern" |
*
* @param {Compliance_Template_Patterns_Count_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_patterns_count_one = /** @type {((inputs: Compliance_Template_Patterns_Count_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Patterns_Count_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Muster`)
	return /** @type {LocalizedString} */ (`${i?.count} pattern`)
});